import { api } from './client.js';

const unwrap = (r) => r.data?.data;

export const dmsApi = {
  folderTree: () => api.get('/documents/folders/tree').then(unwrap),
  listFolders: (parent) => api.get('/documents/folders', { params: parent === null ? { parent: 'null' } : parent ? { parent } : {} }).then(unwrap),
  createFolder: (payload) => api.post('/documents/folders', payload).then(unwrap),

  documents: (params) => api.get('/documents', { params }).then(unwrap),
  getDocument: (id) => api.get(`/documents/${id}`).then(unwrap),
  upload: (file, meta = {}) => {
    const fd = new FormData();
    fd.append('file', file);
    if (meta.folderId) fd.append('folderId', meta.folderId);
    if (meta.name) fd.append('name', meta.name);
    if (meta.description) fd.append('description', meta.description);
    return api.post('/documents/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(unwrap);
  },
  newVersion: (id, file, changeNotes) => {
    const fd = new FormData();
    fd.append('file', file);
    if (changeNotes) fd.append('changeNotes', changeNotes);
    return api.post(`/documents/${id}/new-version`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(unwrap);
  },
  versions: (id) => api.get(`/documents/${id}/versions`).then(unwrap),
  approve: (id, changeNotes) => api.post(`/documents/${id}/approve`, { changeNotes }).then(unwrap),
  link: (payload) => api.post('/documents/link', payload).then(unwrap),
  links: (id) => api.get(`/documents/${id}/links`).then(unwrap),
  forResource: (linkedToType, linkedToId) => api.get('/documents', { params: { linked_to_type: linkedToType, linked_to_id: linkedToId } }).then(unwrap),
};
